<div class="dialog-title mat-tab-label-active text-muted px-3">
  Alert Manager
  <button mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="market-pairs">
  <div class="tab-content">
    <div class="tab-pane fade show active table-custom" id="recent-trades" role="tabpanel">
      <table mat-table [dataSource]="activeAlerts" multiTemplateDataRows class="mat-elevation-z8">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
          <th mat-header-cell *matHeaderCellDef> {{column}} </th>
          <td mat-cell *matCellDef="let element"> {{ column === 'expirationDate' || column === 'triggeredDate' ? (element[column]| date: 'mediumDate') : element[column] }}</td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <div class="example-element-diagram">
                <div class="example-element-position"> {{element.position}} </div>
                <div class="example-element-symbol"> {{element.symbol}} </div>
                <div class="example-element-name"> {{element.name}} </div>
                <div class="example-element-weight"> {{element.weight}} </div>
              </div>
              <div class="example-element-description">
                {{element.description}}
                <span class="example-element-description-attribution"> -- Wikipedia </span>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row" [class.example-expanded-row]="expandedElement === element" (click)="expandedElement = expandedElement === element ? null : element">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </table>

      <!-- <table class="table table-sm table-dark" *ngIf="!isAlertsLoading">
        <thead>
          <tr>
            <th class="fit">Symbol</th>
            <th class="fit">Status</th>
            <th class="fit">Notifications</th>
            <th class="fit">Expiration</th>
            <th class="fit">Triggered Date</th>
            <th class="fit">Alert ID</th>
            <th class="fit">Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of activeAlerts" data-toggle="collapse" data-target="#collapseExample">
            <td class="fit">{{item.symbol}}</td>
            <td class="fit">{{item.status}}</td>
            <td class="fit">{{item.notifications}}</td>
            <td class="fit">{{item.expirationDate | date}}</td>
            <td>{{item.triggeredDate | date}}</td>
            <td>{{item.id}}</td>
          </tr>
          <tr class="collapse" id="collapseExample">
            <div>
              <div class="card card-body">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
              </div>
            </div>
          </tr>
        </tbody>
      </table> -->

      <table class="d-flex justify-content-center" *ngIf="isAlertsLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </table>
      <!-- <div class="table">
        <ngx-datatable [scrollbarH]="true" [loadingIndicator]="isOrdersLoading" class="material" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [rows]="userOrders" [rowHeight]="40">
          <ngx-datatable-column [frozenLeft]="true" *ngIf="translate.currentLang == 'en'" [canAutoResize]="false" [draggable]="false" [width]="250" style="color: whitesmoke !important; text-align: left !important;" name="{{ 'company-name' | translate }}" prop="SymbolNameEn">
          </ngx-datatable-column>
          <ngx-datatable-column prop="OrderNumber" name="Order #">
          </ngx-datatable-column>
          <ngx-datatable-column prop="LastUpdateDate" name="Last Update">
            <ng-template ngx-datatable-cell-template let-value="value">
              {{value | date}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column prop="TransactionId" name="Transaction">
            <ng-template ngx-datatable-cell-template let-value="value">
              <span [ngStyle]="value==1?{'color': 'green'} : {'color': 'red'}">{{getTransaction(value)}}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column prop="OrgQty" name="Qty">
          </ngx-datatable-column>
          <ngx-datatable-column prop="OrgPrice" name="Price">
          </ngx-datatable-column>
          <ngx-datatable-column prop="TradedQty" name="Filled">
          </ngx-datatable-column>
          <ngx-datatable-column prop="PriceType" name="Type">
          </ngx-datatable-column>
          <ngx-datatable-column [minWidth]="80" prop="TiffFlag" name="Duration">
            <ng-template ngx-datatable-cell-template let-value="value">
              {{getTiffFlag(value)}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [minWidth]="110" prop="OrderStatus" name="Status">
            <ng-template role="tabpanel" ngx-datatable-cell-template let-value="value">
              {{getStatus(value)}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Actions" sortable="false" prop="id">
            <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
              {{column.name}}
            </ng-template>
            <ng-template style="height: 40px ;" [minWidth]="110" let-row="row" let-value="value" ngx-datatable-cell-template>
              <button color="primary" mat-icon-button (click)='updateOrder(row)'>
                <mat-icon>edit</mat-icon>
              </button>
              <button color="warn" mat-icon-button (click)='deleteOrder(row)'>
                <mat-icon>delete</mat-icon>
              </button>
            </ng-template>
          </ngx-datatable-column>


        </ngx-datatable>
      </div> -->
    </div>
  </div>
</div>
